import api from 'api'

const UPDATE_DATA = 'realhub/systemManager/agencyImporter/UPDATE_DATA'

// Initial State
const initialState = {
  agencies: [],
}

// Actions
export function updateData(data){
  return {
    type: UPDATE_DATA,
    data,
  }
}

export function searchAgencies(options, callback){
  return (dispatch) => {
    const promise = api(`/admin/brands/${options.brand_id}/importer_api_search.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        dispatch(updateData(json.data))

        if (callback) callback(json)
      })
      .catch(() => {
        const data = []
        dispatch(updateData(data))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type } = action

  switch (type){
    case UPDATE_DATA:
      return Object.assign({}, state, {
        agencies: action.data,
      })
    default:
      return state
  }
}
